import _ from 'lodash';
import moment from 'moment';
import ObjectUtils from '../../../modules/ObjectUtils';

const TransactionStrategy = (() => {
  const service = {};
  service.V2 = 2;
  service.V3 = 3;

  const formatRowsAndHeadersV2 = (transactions = []) => {
    let createdAtIndex;
    const rows = [];
    const headers = ObjectUtils.toLargestKeySet(transactions).map((header, index) => {
      if (header === 'createdAt') {
        createdAtIndex = index;
      }
      return {
        value: header,
        display: _.startCase(header),
      };
    });

    transactions.forEach((transaction) => {
      const row = Object.values(transaction);
      row[createdAtIndex] = moment(row[createdAtIndex])
        .utc()
        .format();
      rows.push({
        value: row,
        raw: transaction,
      });
    });

    return {
      headers,
      rows,
    };
  };

  const formatRowsAndHeadersV3 = (transactions = []) => {
    const rows = [];
    const headers = ObjectUtils.toLargestKeySet(transactions).map(header => ({
      value: header,
      display: _.startCase(header),
    }));

    transactions.forEach((transaction) => {
      rows.push({
        value: Object.values(transaction),
        raw: transaction,
      });
    });

    return {
      headers,
      rows,
    };
  };

  service.getStrategy = (version) => {
    switch (version) {
      case service.V2:
        return {
          version,
          formatRowsAndHeaders: formatRowsAndHeadersV2,
        };
      case service.V3:
        return {
          version,
          formatRowsAndHeaders: formatRowsAndHeadersV3,
        };
      default:
        throw new Error(`An Unknown Version was provided: ${version}`);
    }
  };

  return service;
})();

export default TransactionStrategy;
